import React, { useState } from 'react';
import { Plus, Search, ChevronDown, Clock, Calendar } from 'lucide-react';

// Use the copied assets
import courseImg1 from '../../assets/elearning_1.png';
import courseImg2 from '../../assets/elearning_2.png';

const ELearning = () => {
  const [activeTab, setActiveTab] = useState('Active');
  const [searchTerm, setSearchTerm] = useState('');

  const tabs = [
    { name: 'Active', count: '08' },
    { name: 'Past', count: '20' },
    { name: 'Upcoming', count: '04' },
    { name: 'Draft', count: '10' },
  ];

  const courses = [
    {
      id: 1,
      title: 'Moving and Handling Theory',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg1
    },
    {
      id: 2,
      title: 'Infection control theory & Practical',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg2
    },
    {
      id: 3,
      title: 'Safeguarding adults theory',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg1
    },
    {
      id: 4,
      title: 'Basic first aid practical',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg2
    },
    {
      id: 5,
      title: 'Food hygiene and Dinning dignity theory',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg1
    },
    {
      id: 6,
      title: 'Health and safety practical',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg2
    },
    {
      id: 7,
      title: 'Fire safety & Basic life support practical',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg1
    },
    {
      id: 8,
      title: 'Medication handling theory',
      date: '15 June 2025',
      duration: '01 Hrs 15 Min',
      audience: 'Every staff',
      status: 'Active',
      image: courseImg2
    },
  ];

  return (
    <div className="flex flex-col gap-6 w-full">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800 dark:text-white">E- Learning and supervisions</h1>
          <p className="text-sm text-gray-500 mt-1">Last updated on 20th September 2025</p>
        </div>
        <button className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-colors shadow-sm">
          <Plus className="w-5 h-5" />
          Add new E- learning
        </button>
      </div>

      {/* Content Card */}
      <div className="bg-white dark:bg-[#262b33] rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-6">
        
        {/* Tabs & Filters */}
        <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-6 mb-8">
          
          {/* Tabs */}
          <div className="flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => setActiveTab(tab.name)}
                className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                  activeTab === tab.name
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'bg-white dark:bg-[#31373f] text-gray-600 dark:text-gray-400 border border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-[#3a4048]'
                }`}
              >
                {tab.name} ({tab.count})
              </button>
            ))}
          </div>

          {/* Search & Category */}
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search here......"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2.5 w-full sm:w-64 bg-white dark:bg-[#31373f] border border-gray-100 dark:border-gray-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />
            </div>
            <button className="flex items-center justify-between gap-2 px-4 py-2.5 bg-white dark:bg-[#31373f] border border-gray-100 dark:border-gray-700 rounded-lg text-sm font-semibold text-gray-700 dark:text-gray-300 min-w-[120px]">
              Category
              <ChevronDown className="w-4 h-4 text-gray-400" />
            </button>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {courses.map((course) => (
            <div key={course.id} className="group bg-white dark:bg-[#262b33] rounded-xl overflow-hidden border border-gray-100 dark:border-gray-800 hover:shadow-lg transition-all duration-300">
              {/* Image Section */}
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 right-3 px-2 py-0.5 bg-blue-600 text-white text-[10px] font-bold rounded">
                  Active
                </span>
              </div>

              {/* Content Section */}
              <div className="p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-1.5 text-[11px] font-medium text-gray-400">
                    <Calendar className="w-3 h-3" />
                    {course.date}
                  </div>
                  <div className="flex items-center gap-1.5 text-[11px] font-medium text-gray-400">
                    <Clock className="w-3 h-3" />
                    {course.duration}
                  </div>
                </div>
                
                <h3 className="text-sm font-bold text-gray-800 dark:text-gray-200 leading-tight mb-2 min-h-[2.5rem] line-clamp-2">
                  {course.title}
                </h3>
                
                <p className="text-[12px] text-gray-400">
                  {course.audience}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ELearning;
